import  { useState } from 'react';
import '../../../../../css/CashflowModeller2/Buttons/Close.css';
import { ReactComponent as CloseIcon } from '../../../../../assets/icons/close.svg';

/**
 * Close button component for toggling closed state.
 *
 * Renders a clickable close icon that toggles its closed state when clicked.
 * The component visually updates based on the `isClosed` state.
 *
 * @component
 * @returns {JSX.Element} The rendered close button component.
 */
const Close = () => {
    const [isClosed, setIsClosed] = useState(false);

    const handleClick = () => {
        setIsClosed(!isClosed);
    };

    return (
        <div 
            className={`close-button-container-cfm ${isClosed ? 'closed' : ''}`} 
            onClick={handleClick}
        >
            <div className="close-icon-cfm">
                <CloseIcon />
            </div>
        </div>
    );
};

export default Close;
